export const COLLAPSE = 'navigation/COLLAPSE';
export const EXPAND = 'navigation/EXPAND';
export const TOGGLE = 'navigation/TOGGLE';
